import { Visibility, VisibilityOff } from '@mui/icons-material'
import { Box, Button, FormControl, FormLabel, IconButton, InputAdornment, OutlinedInput, TextField, Select, MenuItem, InputLabel, SelectChangeEvent } from '@mui/material'
import React, { ChangeEvent, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useFinanceTransferMutation } from 'src/redux/api/cabinet';
import { updProfileData } from 'src/redux/slices/app';
import { AppState } from 'src/store/Store';
import { Alerting } from 'src/views/components_cabinet/Alerting';

type CurrencyType = "usdt" | "btc";

export const FormTransferMoney = () => {
    const user = useSelector((state: AppState) => state.app);

    const [showPassword, setShowPassword] = React.useState(false);
    const [login, setLogin] = React.useState<string>('');
    const [amount, setAmount] = React.useState<string>('');
    const [currency, setCurrency] = useState<CurrencyType>("usdt");
    const [FP, setFP] = React.useState<string>('');
    const [getAlert, setgetAlert] = useState<{ type: number, msg: string } | undefined>(undefined);
    const dispatch = useDispatch();

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleCurrencyChange = (e: SelectChangeEvent<CurrencyType>) => {
        setCurrency(e.target.value as CurrencyType);
    };

    const SubmitForm = () => {
        if (login.length === 0) {
            setgetAlert({ type: 2, msg: 'Укажите логин получателя' });
            return false
        }

        const amountNum = parseFloat(amount);

        if (!amount || amountNum === 0 || isNaN(amountNum)) {
            setgetAlert({ type: 2, msg: 'Укажите сумму перевода' });
            return false
        }

        if (FP.length < 8) {
            setgetAlert({ type: 2, msg: 'Укажите Финансовый пароль (от 8 символов)' });
            return false
        }

        const data = {
            finance_password: FP,
            receiver_login: login,
            amount: amountNum,
            currency: currency
        };
        getRequest(data);
    }

    const [getData, { isLoading }] = useFinanceTransferMutation();
    const getRequest = async (data: any) => {
        const jwt = localStorage.getItem('jwt');
        await getData({ body: data, jwt })
            .unwrap()
            .then((payload: any) => {
                dispatch(updProfileData(payload.data));
                setgetAlert({ type: 1, msg: payload.message });
                setLogin('');
                setAmount('');
                setFP('');
            })
            .catch((error: any) => {
                setgetAlert({ type: 2, msg: error.data.message });
            })
    }

    const checkNumberInput = (inputText: string) => {
        // Убираем все символы кроме цифр и точки
        let cleaned = inputText.replace(/[^\d.]/g, "");

        // Убираем все точки кроме первой
        const parts = cleaned.split(".");
        if (parts.length > 2) {
            cleaned = parts[0] + "." + parts.slice(1).join("");
        }

        // Ограничиваем до 10 знаков после точки
        if (parts.length === 2 && parts[1].length > 10) {
            cleaned = parts[0] + "." + parts[1].substring(0, 10);
        }

        return cleaned;
    };

    const getCurrencySymbol = () => {
        return currency === "usdt" ? "$" : "₿";
    };

    const getCurrencyName = () => {
        return currency === "usdt" ? "USDT" : "BTC";
    };

    const getCurrentBalance = () => {
        return currency === "usdt" ? user.data.balance : user.data.balance_btc;
    };

    return (
        <>
            <Box sx={{ width: '100%' }}>
                <FormControl sx={{ width: '100%', mb: 4 }}>
                    <FormLabel htmlFor='login'>
                        Логин получателя
                    </FormLabel>
                    <TextField value={login} size='medium' id="login" variant="outlined"
                        onInput={(el: ChangeEvent<HTMLInputElement>) => setLogin(el.target.value)}
                        placeholder="Логин"
                        inputProps={{
                            autoComplete: 'off',
                        }}
                    />
                </FormControl>

                <FormControl sx={{ width: '100%', mb: 4 }} required>
                    <InputLabel>Валюта</InputLabel>
                    <Select
                        sx={{
                            "&>.MuiOutlinedInput-notchedOutline": {
                                background: 'transparent',
                                border: `1px solid #bebebe`
                            }
                        }}
                        value={currency}
                        label="Валюта"
                        onChange={handleCurrencyChange}
                    >
                        <MenuItem value="usdt">USDT</MenuItem>
                        <MenuItem value="btc">BTC</MenuItem>
                    </Select>
                </FormControl>

                <FormControl sx={{ width: '100%', mb: 4 }}>
                    <FormLabel htmlFor='amount'>
                        Сумма в {getCurrencyName()}
                    </FormLabel>
                    <TextField
                        value={amount}
                        inputMode="decimal"
                        size='medium'
                        id="amount"
                        variant="outlined"
                        type='text'
                        onInput={(el: ChangeEvent<HTMLInputElement>) => setAmount(checkNumberInput(el.target.value))}
                        placeholder="Сумма"
                        inputProps={{
                            inputMode: 'decimal',
                            autoComplete: 'off',
                        }}
                    />
                </FormControl>

                <FormControl sx={{ width: '100%', mb: 4, position: 'relative' }}>
                    <Box display='flex' justifyContent='space-between' alignItems='end' mb={1}>
                        <FormLabel htmlFor='finpas'>
                            Финансовый пароль
                        </FormLabel>
                    </Box>

                    <OutlinedInput
                        value={FP}
                        id="finpas"
                        type={showPassword ? 'text' : 'password'}
                        onInput={(el: ChangeEvent<HTMLInputElement>) => setFP(el.target.value)}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff color='error' /> : <Visibility color='error' />}
                                </IconButton>
                            </InputAdornment>
                        }
                        placeholder="Финансовый пароль"
                        inputProps={{
                            autoComplete: 'off',
                        }}
                    />
                </FormControl>

                <Button
                    onClick={SubmitForm}
                    color='primary'
                    variant='contained'
                    sx={{ width: '100%' }}
                    disabled={isLoading || getCurrentBalance() < parseFloat(amount || '0')}
                >
                    {isLoading
                        ? "Обработка..."
                        : !amount || parseFloat(amount) === 0
                            ? "Отправить"
                            : `Отправить ${getCurrencySymbol()}${new Intl.NumberFormat("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 10
                            }).format(parseFloat(amount))}`
                    }
                </Button>
            </Box>
            {getAlert && <Alerting get={getAlert} />}
        </>
    )
}